import React from 'react'
import Box from '@mui/material/Box';
import classNames from 'classnames'
import PropTypes from 'prop-types'

function Card({
    children,
    margin,
    padding,
    className,
    onClick
}) {
    return (
        <Box
            m={margin}
            p={padding}
            className={classNames(className)}
            onClick={onClick}
        >
            {children}
        </Box>
    )
}
Card.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    margin: PropTypes.string,
    padding: PropTypes.string,
    alignItems: PropTypes.bool,
    onClick: PropTypes.func,
}

export default Card
